module.exports = __webpack_public_path__ + "d151e1aaf6f6b74427f6cf1d709c433a.svg";